import { Action } from 'redux';

import { NormalizedMyLeadersEntities } from '../../normalization/graphql/normalizeMyLeaders.types';

export const userConnectedLeadersListRequestStatusKey = 'userConnectedLeadersListRequestKey';

export interface UserConnectedLeadersListLoadMorePendingAction extends Action {
  readonly type: 'CONNECTED_LEADERS.LOAD_MORE_PENDING';
  readonly userConnectedLeadersListRequestStatusKey: string;
}

export interface UserConnectedLeadersListLoadMoreFulfilledAction extends Action {
  readonly type: 'CONNECTED_LEADERS.LOAD_MORE_FULFILLED';
  readonly userConnectedLeadersListRequestStatusKey: string;
  readonly payload: {
    readonly entities: NormalizedMyLeadersEntities;
  };
}

export interface UserConnectedLeadersListLoadMoreRejectedAction extends Action {
  readonly type: 'CONNECTED_LEADERS.LOAD_MORE_REJECTED';
  readonly userConnectedLeadersListRequestStatusKey: string;
  readonly payload: {
    readonly error: unknown;
  };
  readonly error: true;
}

export type UserConnectedLeadersListLoadMoreAction =
  | UserConnectedLeadersListLoadMorePendingAction
  | UserConnectedLeadersListLoadMoreFulfilledAction
  | UserConnectedLeadersListLoadMoreRejectedAction;
